$(document).ready(function () {
  $(document).on('click',".modal_open", function (e) {
    e.stopPropagation();
    e.preventDefault();
    let modal = $(this).attr("data-modalName");
    $("#" + modal + "").addClass("active");
  })

  $(".custom_modal .close").on('click', function () {
    // console.log("close");
    $(this).closest(".custom_modal").removeClass("active");
  })

  // scroll_actions -active
  $(".scroll_actions li span").on('click', function () {
    $(this).parent().parent().parent(".scroll_actions").toggleClass("active");
  })

  // profile_card_show
  $(document).on('click', ".open_popup", function (e) {
    // e.stopPropagation();
    // e.preventDefault();
    // console.log('yes it is working...')
    $(this).next(".action_popup").toggleClass("active");
  });

  $(document).on('click',".close_popup", function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).closest(".action_popup").removeClass("active");
  })

  $(".docs_mainwrap p, .info_table .accordion-toggle").on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
  })
  $(document).on('click', '.verticalHandle', function (event) {
    if ($(this).hasClass('opened')) {
      $('#leftContentContainer').addClass("d-none");
      $('#rightContentContainer').removeClass("col-md-9");
      $('#rightContentContainer').addClass("col-md-12");
      $('.verticalHandle').toggleClass('closed opened');
    } else {
      $('#leftContentContainer').removeClass("d-none");
      $('#rightContentContainer').addClass("col-md-9");
      $('#rightContentContainer').removeClass("col-md-12");
      $('.verticalHandle').toggleClass('closed opened');
    }
    $('.box').matchHeight();
  });

  $(document).on('click', '.gen-tab', function () {
    showActiveTabContent($(this));
  });
  function showActiveTabContent(thiss) {
    var tabname = thiss.data('tab');
    $('*[data-content], *[data-tab]').removeClass('active');
    $('*[data-content="' + tabname + '"], *[data-tab="' + tabname + '"]').addClass('active');
  }

  // var windowHeight = $(window).height();
  // var navHeight = $('.nav_menu.without_top_omne_bar').height();
  // var secondaryNavHeight = $('.secondary_nav.without_top_omne_bar').height();
  // var sendOffDetailsHeight = $('.sendOff_details').height();
  // $('.doc_inbox').css({'min-height': windowHeight - navHeight - secondaryNavHeight - sendOffDetailsHeight - 55});

  $(document).on('click', '.js_dropdown_container_handler, .has-dropdown .close', function () {
    $(this).closest('.has-dropdown').hasClass('dropdown-on-show') ?
    $(this).closest('.has-dropdown').removeClass('dropdown-on-show') :
    $(this).closest('.has-dropdown').addClass('dropdown-on-show');
  });
  $(document).on('click', '.accordion-toggle', function(){
    if($(this).hasClass('collapsed')){
      $(this).closest('.accordion-heading').addClass('closed');
    }else{
      $(this).closest('.accordion-heading').removeClass('closed');
    }
  });
  // $(document).on('click', '.fa-circle-info', function () {
  //   $(this).closest('.has-popover').toggleClass('active');
  // })
  $(document).on('click', '.has-popover i.fa-xmark', function () {
    $(this).closest('.has-popover').removeClass('active');
  });
})
$(function () {
  $('.box').matchHeight();
});
